import { useState, useEffect } from 'react';

export default function useTransitionListener(element) {
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (!element) return;

    const handleTransitionStart = () => setIsTransitioning(true);
    const handleTransitionEnd = () => setIsTransitioning(false);

    element.addEventListener('transitionstart', handleTransitionStart);
    element.addEventListener('transitionend', handleTransitionEnd);

    return function cleanupTransitionListeners() {
      element.removeEventListener('transitionstart', handleTransitionStart);
      element.removeEventListener('transitionend', handleTransitionEnd);
    };
  }, [element]);

  return isTransitioning;
}
